exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__payment-card___3P1lS{width:21rem;min-width:21rem;max-width:21rem;height:13.5rem;min-height:13.5rem;max-height:13.5rem}.styles__payment-card___3P1lS .styles__front___2lgsp{display:flex;flex-flow:column}", ""]);

// exports
exports.locals = {
	"payment-card": "styles__payment-card___3P1lS",
	"front": "styles__front___2lgsp"
};